module.exports = "<div class=\"dialog-wrapper\">\r\n    <mat-dialog-content fxLayout=\"column\">\r\n        <h1 class=\"mat-dialog-title\">Chyby při importu</h1>\r\n    </mat-dialog-content>\r\n\r\n    <textarea cols=\"100\" rows=\"20\">{{message}}</textarea>\r\n\r\n    <mat-dialog-actions [fxLayout]=\"row\">\r\n        <div fxLayoutAlign=\"end center\" fxFlex>\r\n            <button mat-raised-button (click)=\"dialogRef.close('cancel')\"><mat-icon>clear</mat-icon> Zavřít</button>\r\n        </div>\r\n    </mat-dialog-actions>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-import-error-overview/product-import-error-overview.component.html
// module id = 1495
// module chunks = 0